module.exports = __webpack_public_path__ + "static/img/ygzx.53d92ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ygzx.png
// module id = 9S3y
// module chunks = 0